import { urls } from "app/constants";
import { dtoRecovery } from "app/utils/dto";
import { axiosBase } from "./_api";
import { path } from "ramda";

export const apiActivate = (
  params: any,
  success: any,
  unsuccess: any,
  setErrors: any
) => {
  axiosBase({
    url: urls.activate,
    method: "post",
    data: dtoRecovery(params),
  })
    .then(success)
    .catch((error) => {
      if (
        error.response &&
        error.response.data &&
        error.response.status === 400
      ) {
        // console.log("API REG ERROR 400", error);
        let fieldErr: any = path(["response", "data", "errors"], error) || {};
        let codeErr: any = path(["response", "data", "code"], error) || "";
        let detailErr: any = path(["response", "data", "details"], error) || {};

        if (codeErr === "invalid_form") {
          if (fieldErr.email) {
            fieldErr.email = fieldErr.email.map((e: string) => {
              if (e === "does_not_exist") return "Email не зарегистрирован";
              return "n";
            });
          }
        }

        if (codeErr === "email_is_already_approve") {
          fieldErr.email = ["Аккаунт уже активирован"];
        }

        if (codeErr === "time_limit_expired") {
          fieldErr.email = [
            `Количество секунд до следующей отправки запроса ${detailErr.time} `,
          ];
        }

        if (codeErr === "number_of_attempts_exceeded") {
          fieldErr.email = [`Количество запросов исчерпано. Попробуй завтра`];
        }

        // console.log(fieldErr);
        setErrors(fieldErr);
      }
      return unsuccess(error);
    });
};
